module.exports = __webpack_public_path__ + "assets/images/46cc582c91ecd49ab236d735e24023a5.png";